import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function uploadDeveloperImage(body: any,name:any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.UPLOADDEVELOPERIMAGE}/${name}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getSector(payload:any) {
  try {
    // Avoid calling missing/empty sector list on production when filters are blank
    if (!payload?.city && !payload?.zone && !payload?.search && !payload?.id) {
      return { success: 1, data: [] };
    }
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETSECTOR}?search=${payload?.search || ""}&page=${payload?.page || 0}&limit=${payload?.limit || 25}&city=${payload?.city || ""}&zone=${payload?.zone || ""}`, callParams);
    return response;
  } catch (error: any) {
    if (error?.status === 404) {
      return { success: 0, data: [] };
    }
    throw error;
  }
}

export async function getSectorById(id:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETSECTOR}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addSector(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDSECTOR, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteSector(id:any) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(`${urls.DELETESECTOR}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}